/*
 * @Author: centerm.gaohan 
 * @Date: 2020-10-29 09:53:34 
 * @Last Modified by: centerm.gaohan
 * @Last Modified time: 2020-11-26 10:47:59
 */

import React, { useState, useReducer, useEffect } from 'react';
import { api } from '../app';
import { useRequest } from 'ahooks'
import moment from 'moment';

const Action_Types = {
  RECEIVE_USER_STATUS: 'RECEIVE_USER_STATUS',
  RECEIVE_MODEL_STATUS: 'RECEIVE_MODEL_STATUS',
  RECEIVE_MEET_INDEX: 'RECEIVE_MEET_INDEX',
}

const initState = {
  userstatus: {},
  modelstatus: {},
  meetindex: {},
  datecontrol: {
    min: '',
    max: ''
  },
};

/**
 * 全局用户状态
 */
function reducer(state: any, action: any) {
  switch (action.type) {
    case Action_Types.RECEIVE_USER_STATUS: {
      return {
        ...state,
        userstatus: action.payload
      }
    }

    case Action_Types.RECEIVE_MODEL_STATUS: {
      return {
        ...state,
        modelstatus: action.payload
      }
    }

    case Action_Types.RECEIVE_MEET_INDEX: {
      const { payload } = action;
      const min = new Date(moment(payload.start_time * 1000).subtract(3, 'days').format('YYYY-MM-DD'))
      const max = new Date(moment(payload.end_time * 1000).add(3, 'days').format('YYYY-MM-DD'))
      return {
        ...state,
        meetindex: action.payload,
        datecontrol: {
          min,
          max
        }
      }
    }

    default: {
      return {
        ...state
      }
    }
  }
}

const useUserStatus = (meetid?: any) => {
  const [state, dispatch] = useReducer(reducer, initState);

  const { run } = useRequest((api as any).showButton, {
    manual: true,
    onSuccess: (result) => {
      console.log("onSuccess", result);
      if (result.code === 200) {
        dispatch({
            type: Action_Types.RECEIVE_USER_STATUS,
            payload: result.result,
        });
      }
    }
  });

  const refreshUserstatus = async  () => {
    const result = await run({ meetid });
    if (result.code === 200) {
      return result.result;
    }
    return result;
  };

  useEffect(() => {
    if (meetid) {
      run({ meetid });
    }
  }, [meetid]);

  useEffect(() => {
    if (meetid) {
      (api as any).getTypeShowButton({ meetid })
        .then((result: any) => {
          if (result.code === 200) {
            dispatch({
              type: Action_Types.RECEIVE_MODEL_STATUS,
              payload: result.result
            })
          }
        })
    }
  }, [meetid]);

  useEffect(() => {
    if (meetid) {
      (api as any).getMeetingIndex(meetid).then(
        (res: any) => {
          if (res.code === 200) {
            document.title = res.result.title ?? '会佰分';
            dispatch({
              type: Action_Types.RECEIVE_MEET_INDEX,
              payload: res.result
            })
          }
        },
        (err: any) => {
          console.log(err);
        }
      );
    }
  }, [meetid])

  return {
    userstatus: state.userstatus,
    modelstatus: state.modelstatus,
    meetindex: state.meetindex,
    datecontrol: state.datecontrol,
    dispatch,
    actionTypes: {
        update: Action_Types.RECEIVE_USER_STATUS,
        model: Action_Types.RECEIVE_MODEL_STATUS,
        meet: Action_Types.RECEIVE_MEET_INDEX
    },
    refreshUserstatus: refreshUserstatus,
  };
}

export { useUserStatus }